/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "./BaseCom";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import AppActions from "./AppActions";
import Card from "./Card";
import Icon from "./Icon";
import L from "./Lang";
import { qreq } from "../shared/qrequest";
import { Modal, Spinner } from "react-bootstrap";
import Globals from "../shared/Globals";
import './ProductList2.css';
import Alert from "./Alert";
import FormInput from "./FormInput";
import { Pop } from "./PopModal";

class ProductList2Catalog extends BaseCom {
    constructor(props) {
        super(props);

        this.state = {
            products: null,
            moreInfoProduct: null,
            moreInfoProductZ: null,
            loadingProduct: false
        };
    }

    async componentDidMount() {
        await this.load();
    }

    load = async () => {
        try {
            const j = await qreq.getAsync("/api/product/list");

            if (j.list) {
                this.setState({ products: j.list });
            } else {
                this.alert(j.errorMessage);
            }
        } catch (e) {
            this.unkownErrorCallback(e);
        }
    };

    selectProduct = (product) => {
        if (this.props.onSelect) {
            this.props.onSelect(product);
        }
    };

    moreInfo = async (product) => {
        this.setState({
            moreInfoProduct: product,
            moreInfoProductZ: null,
            loadingProduct: true
        });

        try {
            const j = await qreq.getAsync("/api/product/get/" + product.id);

            if (j.item) {
                this.setState({
                    moreInfoProductZ: j.item,
                    loadingProduct: false
                });
            } else {
                this.setState({ loadingProduct: false });
                this.alert(j.errorMessage);
            }
        } catch (e) {
            this.setState({ loadingProduct: false });
            this.unkownErrorCallback(e);
        }
    };

    closeMoreInfo = () => {
        this.setState({
            moreInfoProduct: null,
            moreInfoProductZ: null
        });
    };

    getProductImage = (product) => {
        if (product.imageIdent) {
            return Globals.getStorageURL(product.imageIdent);
        }

        if (product.productName) {
            return "/img/products/" + product.productName.toLowerCase() + ".png";
        }

        return null;
    };

    renderCatalog = () => {
        const { products } = this.state;

        if (!products) {
            return (
                <div className="text-center py-5">
                    <Spinner animation="border" />
                    <div className="mt-3 text-muted">
                        <L>Loading products...</L>
                    </div>
                </div>
            );
        }

        if (products.length === 0) {
            return (
                <Alert variant="info" className="mb-0">
                    <L>No products are currently available.</L>
                </Alert>
            );
        }

        return (
            <>
                <div className="mb-4">
                    <h5 className="mb-1">
                        <L>Select a Product</L>
                    </h5>

                    <div className="text-muted">
                        <L>
                            Choose a product from the catalog to add it to this order.
                        </L>
                    </div>
                </div>

                <div className="row g-4">
                    {products.map((product) => {
                        const image = this.getProductImage(product);

                        return (
                            <div
                                key={product.id || product.productName}
                                className="col-12 col-sm-6 col-lg-4"
                            >
                                <div className="card h-100 shadow-sm border-0 product-catalog-card">
                                    <div className="product-catalog-image-container">
                                        {image ? (
                                            <img
                                                src={image}
                                                alt={product.productName || ""}
                                                className="product-catalog-image"
                                            />
                                        ) : (
                                            <div className="product-catalog-no-image">
                                                <Icon icon="faBox" />
                                            </div>
                                        )}
                                    </div>

                                    <div className="card-body d-flex flex-column">
                                        <div className="mb-3">
                                            <h5 className="card-title mb-1">
                                                {product.productName}
                                            </h5>

                                            {product.manufacturer && (
                                                <div className="text-muted small">
                                                    {product.manufacturer}
                                                </div>
                                            )}
                                        </div>

                                        <div className="mt-auto">
                                            <div className="d-grid gap-2">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary"
                                                    onClick={() =>
                                                        this.selectProduct(product)
                                                    }
                                                >
                                                    <Icon icon="faPlus" />{" "}
                                                    <L>Add Product</L>
                                                </button>

                                                {(product.specs ||
                                                    product.description) && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-secondary"
                                                            onClick={() =>
                                                                this.moreInfo(product)
                                                            }
                                                        >
                                                            <Icon icon="faCircleInfo" />{" "}
                                                            <L>View Details</L>
                                                        </button>
                                                    )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </>
        );
    };

    renderMoreInfo = () => {
        const product = this.state.moreInfoProduct;
        const detail = this.state.moreInfoProductZ;

        return (
            <div className="product-detail">
                <div className="d-flex align-items-center mb-4">
                    <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={this.closeMoreInfo}
                    >
                        <Icon icon="faArrowLeft" /> <L>Back to Catalog</L>
                    </button>
                </div>

                <div className="row g-4">
                    <div className="col-lg-5">
                        <div className="product-detail-image-panel">
                            {this.state.loadingProduct ? (
                                <div className="text-center py-5">
                                    <Spinner animation="border" />
                                </div>
                            ) : detail?.images?.length > 0 ? (
                                <>
                                    <img
                                        src={Globals.getStorageURL(
                                            detail.images[0].imageIdent
                                        )}
                                        className="img-fluid product-detail-main-image"
                                        alt={product.productName || ""}
                                    />

                                    {detail.images.length > 1 && (
                                        <div className="row g-2 mt-2">
                                            {detail.images.slice(1).map((image, idx) => (
                                                <div
                                                    className="col-4"
                                                    key={image.imageIdent || idx}
                                                >
                                                    <div className="product-detail-thumbnail">
                                                        <img
                                                            src={Globals.getStorageURL(
                                                                image.imageIdent
                                                            )}
                                                            alt=""
                                                            className="img-fluid"
                                                        />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </>
                            ) : (
                                <div className="product-detail-no-image">
                                    <Icon icon="faBox" />
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="col-lg-7">
                        <div className="ps-lg-3">
                            {product.manufacturer && (
                                <div className="text-muted text-uppercase small fw-semibold mb-2">
                                    {product.manufacturer}
                                </div>
                            )}

                            <h2 className="mb-4">
                                {product.productName}
                            </h2>

                            {product.description && (
                                <div className="mb-4">
                                    <h6 className="fw-bold mb-2">
                                        <L>Description</L>
                                    </h6>

                                    <div className="product-detail-text">
                                        {product.description}
                                    </div>
                                </div>
                            )}

                            {product.specs && (
                                <div className="mb-4">
                                    <h6 className="fw-bold mb-2">
                                        <L>Specifications</L>
                                    </h6>

                                    <div className="product-specifications">
                                        {product.specs}
                                    </div>
                                </div>
                            )}

                            <div className="d-grid d-sm-block pt-2">
                                <button
                                    type="button"
                                    className="btn btn-primary btn-lg px-4"
                                    onClick={() => this.selectProduct(product)}
                                >
                                    <Icon icon="faPlus" />{" "}
                                    <L>Add this Product</L>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    render() {
        if (!this.props.show) return null;

        return (
            <Modal
                show={this.props.show}
                onHide={this.props.onHide}
                size="xl"
                centered
                scrollable
                className="product-catalog-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {this.state.moreInfoProduct ? (
                            <L>Product Details</L>
                        ) : (
                            <L>Product Catalog</L>
                        )}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="p-4">
                    {this.state.moreInfoProduct
                        ? this.renderMoreInfo()
                        : this.renderCatalog()}
                </Modal.Body>
            </Modal>
        );
    }
}

class ProductList2 extends BaseCom {
    constructor(props) {
        super(props);

        this.state = {
            showCatalogModal: false
        };
    }

    componentDidMount() {
        this.arg();
    }

    componentDidUpdate(prevProps) {
        if (this.props.arg !== prevProps.arg)
            this.arg();
    }

    arg = () => {
        if (this.props.arg === 'add')
            this.setState({ showCatalogModal: true });
    }

    selectProduct = async (product) => {
        const info = { ...product, orderID: this.props.order.id };
        try {
            const j = await qreq.postAsync('/api/order/product/add', info);
            if (j.errorCode === 0) {
                this.success('Added product.');
                this.props.onSelectProduct(product);
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }

        this.setState({
            showCatalogModal: false
        });
    };

    editProduct = (product) => {
        product.edit = true;
        this.forceUpdate();
    }

    cancelEditProduct = (product) => {
        product.edit = false;
        this.forceUpdate();
        this.props.onCancelEditProduct(product);
    }

    removeProduct = (product) => {
        Pop.showConfirm(<><L>Are you sure you want to remove product: </L> <strong>{product.productName}</strong> <i>{product.lotNumber}</i></>, <L>Remove Product</L>, async () => {
            const info = { ...product, orderID: this.props.order.id };
            try {
                const j = await qreq.postAsync('/api/order/product/remove', info);
                if (j.errorCode === 0) {
                    this.success('Removed product.');
                    this.props.onRemoveProduct();
                }
                else
                    this.alert(j.errorMessage);
            }
            catch (e) {
                this.unkownErrorCallback(e);
            }
        });
    };

    saveProduct = async (product) => {
        const info = { ...product, orderID: this.props.order.id };
        try {
            const j = await qreq.postAsync('/api/order/product/save', info);
            if (j.errorCode === 0) {
                this.success('Saved!');
                product.edit = false;
                this.props.onSaveProduct();
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    renderProducts = () => {
        const products = this.props.order?.products;

        if (!products) {
            return (
                <Alert variant="warning" className="mb-0">
                    <Spinner
                        animation="border"
                        size="sm"
                        className="me-2"
                    />
                    <L>Loading products...</L>
                </Alert>
            );
        }

        if (products.length === 0) {
            return (
                <div className="text-center py-5">
                    <div className="product-list-empty-icon mb-3">
                        <Icon icon="faBoxOpen" />
                    </div>

                    <h5>
                        <L>No Products Added</L>
                    </h5>

                    <div className="text-muted mb-4">
                        <L>
                            There are no products ordered for this patient.
                        </L>
                    </div>

                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() =>
                            this.setState({ showCatalogModal: true })
                        }
                    >
                        <Icon icon="faPlus" /> <L>Add Product</L>
                    </button>
                </div>
            );
        }

        return (
            <div className="table-responsive" style={{ overflow: 'visible' }}>
                <table className="table align-middle mb-0 product-list-table">
                    <thead>
                        <tr>
                            <th>
                                <L>Product</L>
                            </th>

                            <th>
                                <L>Manufacturer</L>
                            </th>

                            <th>
                                <L>Lot Number</L>
                            </th>

                            <th>
                                <L>Exp. Date</L>
                            </th>

                            <th></th>
                        </tr>
                    </thead>

                    <tbody>
                        {products.map((product, idx) => (
                            <tr key={product.id || idx}>
                                <td>
                                    <div className="fw-semibold">
                                        {product.productName}
                                    </div>
                                </td>

                                <td className="text-muted">
                                    {product.manufacturer || "—"}
                                </td>

                                <td>
                                    {product.edit ? <FormInput model={product.orderProduct} name="lotNumber" label="Lot Number" labelAsPlaceholder /> : product.orderProduct?.lotNumber}
                                </td>

                                <td>
                                    {product.edit ? <FormInput model={product.orderProduct} name="inputExpirationDate" type="date" label="Exp. Date" labelAsPlaceholder /> : Globals.toMDYLocalDateString(product.orderProduct?.expirationDate)}
                                </td>

                                <td>
                                    {product.edit ? <>
                                        <button type="button" className="btn btn-success btn-lg" onClick={() => this.saveProduct(product)}>
                                            <Icon icon="faSave" />
                                        </button>
                                        <button type="button" className="btn btn-danger btn-lg ms-1" onClick={() => this.removeProduct(product)}>
                                            <Icon icon="faTrash" />
                                        </button>
                                        <button type="button" className="btn btn-secondary btn-lg ms-1" onClick={() => this.cancelEditProduct(product)}>
                                            <Icon icon="faCancel" />
                                        </button>
                                    </> : <>
                                        <button type="button" className="btn btn-primary btn-lg" onClick={() => this.editProduct(product)}>
                                            <Icon icon="faPencil" />
                                        </button>
                                    </>}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    };

    render() {
        return (
            <>
                <ProductList2Catalog
                    show={this.state.showCatalogModal}
                    onHide={() =>
                        this.setState({ showCatalogModal: false })
                    }
                    onSelect={this.selectProduct}
                />

                <AppActions>
                    <button
                        type="button"
                        className="btn btn-primary btn-lg"
                        onClick={() =>
                            this.setState({ showCatalogModal: true })
                        }
                    >
                        <Icon icon="faPlus" /> <L>Add Product</L>
                    </button>
                </AppActions>

                <Card
                    title="Products"
                    headerButtons={
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() =>
                                this.setState({
                                    showCatalogModal: true
                                })
                            }
                        >
                            <Icon icon="faPlus" /> <L>Add Product</L>
                        </button>
                    }
                >
                    {this.renderProducts()}
                </Card>
            </>
        );
    }
}

export default withParamsAndNavigate(ProductList2);